<script>
  import axios from "axios"
  import ApplicationState from "../../../Stores/applicationStates"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { push } from "svelte-spa-router"
  import notify from "../../../Script/notify"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import { postRequest } from "../../../Script/apiMethods"

  let apiCallBtnDisable = false
  let newPass = false

  // input values
  let oldPassword = ""
  let newPassword = ""
  let confirmPassword = ""

  //bind variables
  let oldPassField
  let newPassField
  let confirmPassField

  let showOLdPassword = false
  let showNewPassword = false
  let showConfirmPassword = false
  // let passwordregex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&+=!])(?=.{12,})/
  let passwordregex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$-&*_+.!])(?=.{12,})/

  /**
   * @type {passwodeNotify}
   */
  let passwodeNotify = {
    close() {},
  }

  const checkOldPasscode = () => {
    try {
      if (!oldPassword) throw "Don't leave empty field"
      newPass = true
      showConfirmPassword = false
      showNewPassword = false
    } catch (error) {
      passwodeNotify.close()
      const info = "PAGE: Change Password\nEVENT: While proceeding to change password with empty old password"
      passwodeNotify = notify.danger(error, info)
    }
  }

  const setNewPasscode = async () => {
    try {
      if (!newPassword || !confirmPassword) throw "Don't leave empty field"

      if (!passwordregex.test(newPassword)) throw "Invalid password pattern found"

      if (newPassword == oldPassword) throw "The new password must differ from your current password. Please choose a password distinct from the old one."

      if (newPassword != confirmPassword) throw "The new password and confirm password must be identical, but they don't match at the moment."

      try {
        apiCallBtnDisable = true

        await postRequest(
          `/api/swagger/v2/account/change-password`,
          {
            oldPassword: oldPassword,
            newPassword: confirmPassword,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        push("/settings/security/success")
        notify.success("Success! Your password has been changed.")
      } catch (error) {
        // Show an error notification
        newPass = false
        oldPassword = ""
        newPassword = ""
        confirmPassword = ""
        throw error
      } finally {
        passwordStrengthLevel = 0
        apiCallBtnDisable = false
      }
    } catch (error) {
      console.error(error)
      passwodeNotify.close()
      const info = "PAGE: Change Password\nEVENT: While changing password"
      passwodeNotify = notify.danger(error, info)
    }

    // newPass = false
  }

  let passwordStrengthLevel = false

  const calculatePasswordComplexity = (password) => {
    // Define criteria and weights (you can adjust these as needed)
    const criteria = [
      { regex: /[a-z]/, weight: 1 }, // Lowercase letters
      { regex: /[A-Z]/, weight: 2 }, // Uppercase letters
      { regex: /[0-9]/, weight: 2 }, // Numbers
      { regex: /[@#$%^&+=!]/, weight: 2 }, // Special characters
      { fn: (pass) => pass.length >= 4, weight: 1 }, // Minimum length of 8
      { fn: (pass) => pass.length >= 8, weight: 2 }, // Minimum length of 8
      { fn: (pass) => pass.length >= 12, weight: 3 }, // Minimum length of 8
      // password.length>3
    ]

    let score = 0

    criteria.forEach((criterion) => {
      if (criterion.regex) {
        if (criterion.regex.test(password)) {
          score += criterion.weight
        }
      } else if (criterion.fn) {
        if (criterion.fn(password)) {
          score += criterion.weight
        }
      }
    })
    return score
  }
</script>

<svelte:head>
  <title>Settings Security</title>
</svelte:head>
<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <div class="relative mt-6 flex min-h-[470px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        {#if !newPass}
          <form on:submit|preventDefault|stopPropagation={checkOldPasscode} class="flex h-full flex-col justify-between gap-6">
            <div class="space-y-3">
              <h1 class="lineHeight text-3xl font-extrabold dark:text-white mobile:text-5xl">
                Change <br />
                Password
              </h1>
              <!-- <p class=" w-full text-gray-200 lg:w-3/5">If you want to create new password, enter old password here and proceed to next page</p> -->
              <p class=" w-full text-gray-200 lg:w-3/5">To change your password, enter your current password. You will remain logged in on current devices until tokens expire.</p>
              <div class="pt-6 mobile:w-3/4 sm:w-3/4 md:w-1/2">
                <p class="mb-1.5 select-none text-sm text-gray-200 mobile:font-medium">Old Password</p>
                <div class="group relative mb-3 w-full mobile:mb-10">
                  <input required bind:value={oldPassword} bind:this={oldPassField} type="password" placeholder="Enter Old Password" class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-9 py-2 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />

                  <div class="absolute {!oldPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} inset-y-0 left-0 flex aspect-square items-center justify-center">
                    <i class="fa-solid fa-lock" />
                  </div>

                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <div
                    on:click={() => {
                      showOLdPassword = !showOLdPassword
                      if (!showOLdPassword) oldPassField.type = "password"
                      else oldPassField.type = "text"
                    }}
                    class="absolute cursor-pointer {!oldPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} inset-y-0 right-0 flex aspect-square items-center justify-center"
                  >
                    {#if showOLdPassword}
                      <i class="fa-solid fa-eye-slash" />
                    {:else}
                      <i class="fa-solid fa-eye" />
                    {/if}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button type="submit" class="float-right flex h-9 w-20 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4">
                Next&nbsp;&nbsp;
                <i class="fa-solid fa-chevron-right" />
              </button>
            </div>
          </form>
        {:else}
          <form on:submit|preventDefault|stopPropagation={setNewPasscode} class="flex min-h-[470px] flex-col justify-between">
            <div class="space-y-3">
              <h1 class="lineHeight select-none text-3xl font-extrabold dark:text-white mobile:text-5xl">
                Create new <br />
                Password
              </h1>
              <p class="w-full select-none text-gray-200 lg:w-3/5">Your new password must be different from your previous passwords and meet the specified criteria</p>
              <div class="flex pt-6">
                <div class="w-full space-y-3 sm:w-3/4 md:w-1/2">
                  <div>
                    <div class="flex justify-between">
                      <p class="mb-1.5 select-none text-sm text-gray-200 mobile:font-medium">New Password</p>
                      <div class="flex items-center gap-1.5">
                        <div class="h-1 w-6 rounded-full {passwordStrengthLevel >= 12 ? 'bg-green-500' : passwordStrengthLevel >= 10 ? 'bg-yellow-500' : passwordStrengthLevel <= 10 && passwordStrengthLevel != 0 ? 'bg-red-500' : 'bg-gray-500'} " />
                        <div class="h-1 w-6 rounded-full {passwordStrengthLevel >= 12 ? 'bg-green-500' : passwordStrengthLevel >= 10 ? 'bg-yellow-500' : 'bg-gray-500'}" />
                        <div class="h-1 w-6 rounded-full {passwordStrengthLevel >= 12 ? 'bg-green-500' : 'bg-gray-500'}" />
                      </div>
                    </div>
                    <div class="group relative w-full">
                      <input
                        on:input={(e) => {
                          passwordStrengthLevel = calculatePasswordComplexity(e.target.value)
                        }}
                        required
                        bind:value={newPassword}
                        bind:this={newPassField}
                        type="password"
                        placeholder="Enter New Password"
                        class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-9 py-2 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm"
                      />

                      <div class="absolute {!newPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} inset-y-0 left-0 flex aspect-square items-center justify-center text-gray-200">
                        <i class="fa-solid fa-lock" />
                      </div>

                      <!-- svelte-ignore a11y-click-events-have-key-events -->
                      <div
                        on:click={() => {
                          showNewPassword = !showNewPassword
                          if (!showNewPassword) newPassField.type = "password"
                          else newPassField.type = "text"
                        }}
                        class="absolute cursor-pointer {!newPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} inset-y-0 right-0 flex aspect-square items-center justify-center"
                      >
                        {#if showNewPassword}
                          <i class="fa-solid fa-eye-slash" />
                        {:else}
                          <i class="fa-solid fa-eye" />
                        {/if}
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="mb-1.5 select-none text-sm text-gray-200 mobile:font-medium">Confirm New Password</p>
                    <div class="group relative w-full">
                      <input
                        required
                        on:focus={() => {
                          if (newPassword == oldPassword) {
                            passwodeNotify.close()
                            const info = "PAGE: Change Password\nEVENT: Validation of New password against the old one whether its different or not during onFocus"
                            passwodeNotify = notify.danger("New password must be different from old password", info)
                          }
                        }}
                        bind:value={confirmPassword}
                        bind:this={confirmPassField}
                        disabled={newPassword.length < 12}
                        type="password"
                        placeholder="Enter New Password"
                        class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-9 py-2 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:cursor-not-allowed disabled:border-red-500 disabled:placeholder:text-red-500 dark:text-white sm:text-sm"
                      />

                      <div class="absolute {!confirmPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} inset-y-0 left-0 flex aspect-square items-center justify-center">
                        <i class="fa-solid fa-lock" />
                      </div>

                      <!-- svelte-ignore a11y-click-events-have-key-events -->
                      <div
                        on:click={() => {
                          showConfirmPassword = !showConfirmPassword
                          if (!showConfirmPassword) confirmPassField.type = "password"
                          else confirmPassField.type = "text"
                        }}
                        class="absolute inset-y-0 right-0 cursor-pointer {!confirmPassword ? 'text-red-500' : 'text-gray-200 focus:text-blue-500 group-focus-within:text-blue-500'} flex aspect-square items-center justify-center"
                      >
                        {#if showConfirmPassword}
                          <i class="fa-solid fa-eye-slash" />
                        {:else}
                          <i class="fa-solid fa-eye" />
                        {/if}
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="hidden flex-col justify-center pl-10 sm:flex sm:w-3/4 md:w-1/2">
                  <li>
                    <div class="w-auto select-none">
                      <p class="text-xs font-medium {newPassword.match(/[A-Z]/) ? 'text-green-500' : 'text-gray-200'}">At least one Uppercase letter (A-Z)</p>
                    </div>
                    <!-- <div class="flex h-5 w-5 cursor-pointer items-center justify-center rounded-md {newPassword.match(/[A-Z]/) ? 'bg-green-500' : 'bg-gray-200'} text-xs text-white">
                    <i class="fa-solid fa-check" />
                  </div> -->
                  </li>
                  <li>
                    <div class="w-auto select-none">
                      <p class="text-xs font-medium {newPassword.match(/[a-z]/) ? 'text-green-500' : 'text-gray-200'}">At least one lowercase letter (a-z)</p>
                    </div>
                    <!-- <div class="flex h-5 w-5 cursor-pointer items-center justify-center rounded-md {newPassword.match(/[a-z]/) ? 'bg-green-500' : 'bg-gray-200'} text-xs text-white">
                    <i class="fa-solid fa-check" />
                  </div> -->
                  </li>
                  <li>
                    <div class="w-auto select-none">
                      <p class="text-xs font-medium {newPassword.match(/[@#$\-\&*_+.!]/) ? 'text-green-500' : 'text-gray-200'}">At least one special character from [!@#$&*_-+.]</p>
                    </div>
                    <!-- <div class="flex h-5 w-5 cursor-pointer items-center justify-center rounded-md {newPassword.match(/[@#$-&*_+.!]/) ? 'bg-green-500' : 'bg-gray-200'} text-xs text-white">
                    <i class="fa-solid fa-check" />
                  </div> -->
                  </li>
                  <li>
                    <div class="w-auto select-none">
                      <p class="text-xs font-medium {newPassword.match(/[0-9]/) ? 'text-green-500' : 'text-gray-200'}">At least one number (0-9)</p>
                    </div>
                    <!-- <div class="flex h-5 w-5 cursor-pointer items-center justify-center rounded-md {newPassword.match(/[0-9]/) ? 'bg-green-500' : 'bg-gray-200'} text-xs text-white">
                    <i class="fa-solid fa-check" />
                  </div> -->
                  </li>
                  <li>
                    <div class="w-auto select-none">
                      <p class="text-xs font-medium {newPassword.length >= 12 ? 'text-green-500' : 'text-gray-200'}">Minimum length of 12 characters</p>
                    </div>
                    <!-- <div class="flex h-5 w-5 cursor-pointer items-center justify-center rounded-md {newPassword.length >= 12 ? 'bg-green-500' : 'bg-gray-200'} text-xs text-white">
                    <i class="fa-solid fa-check" />
                  </div> -->
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex items-center justify-between">
              <button
                on:click={() => {
                  showOLdPassword = false
                  newPass = false
                }}
                type="button"
                class="flex h-9 w-20 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4"
              >
                <i class="fa-solid fa-chevron-left" />
                &nbsp;&nbsp;Back
              </button>
              <button type="submit" class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 lg:px-4">
                <i class="fa-solid fa-check" />
                &nbsp;&nbsp;Change Password
              </button>
            </div>
          </form>
        {/if}
        {#if apiCallBtnDisable}
          <LoadingScreen msg={"Checking password"} />
        {/if}
      </div>
    </div>
  </div>

  <Footer />
</div>

<style>
  .lineHeight {
    line-height: 4rem;
  }
</style>
